export default __webpack_public_path__ + "static/media/RestrictionFigure1.6e2e55bc.svg";